import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

export const Subheader = ({ text }: { text: string }) => (
  <Typography className="cur-mt-2" size="h2">
    {text}
  </Typography>
);
